import { parseTypedAmount, type TypedAmount } from '@/lib/number';
import { roundToColumnScale, type ParamDef } from '@/lib/waterModel';

// One comma group ("1,250"): a thousands group or a decimal, which parseTypedAmount refuses to guess.
const ONE_COMMA_GROUP = /^[-+]?\d{1,3},\d{3}$/;

/**
 * A typed grid cell as the number the database will hold. Parsed in decimal mode so a comma
 * group ("1,250") asks which it is instead of being read as 1.25; a whole-number column
 * (decimals 0) refuses any decimal, and the rest are rounded to the column's scale so
 * the screen shows what is stored.
 */
export function parseGridValue(param: ParamDef, text: string): TypedAmount {
  const parsed = parseTypedAmount(text);
  const whole = param.decimals === 0;
  if ('error' in parsed) {
    if (whole && ONE_COMMA_GROUP.test(text.trim())) {
      return { error: `${param.label} takes whole numbers. Type ${text.trim().replace(',', '')} without the comma.` };
    }
    return parsed;
  }
  if (parsed.value === null) return parsed;
  if (whole && !Number.isInteger(parsed.value)) return { error: `${param.label} takes whole numbers.` };
  return { value: roundToColumnScale(param.key, parsed.value) };
}
